import { render, staticRenderFns } from "./ScatterTest.vue?vue&type=template&id=9837e232&"
import script from "./ScatterTest.vue?vue&type=script&lang=js&"
export * from "./ScatterTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports